import defShatner from "./series/shatner";

const getSeries = (series) => {
	return defShatner;
}

export default {
	getSeries,
}